import { getMerchantToken } from "./merchantAuthApi";

const BASE = (process.env.REACT_APP_MERCHANT_API_BASE_URL || "http://secondbite-manage.localhost/merchant-api/v1").replace(/\/+$/, "");
const query = (filters) => new URLSearchParams(filters).toString();

export const getSalesReport = async (filters) => {
  const response = await fetch(`${BASE}/reports/sales?${query(filters)}`, { headers: { Accept: "application/json", Authorization: `Bearer ${getMerchantToken()}` } });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) throw new Error(payload?.message || "Unable to load sales report.");
  return payload.data;
};

export const exportSalesReport = async (filters) => {
  const response = await fetch(`${BASE}/reports/sales/export?${query(filters)}`, { headers: { Accept: "text/csv", Authorization: `Bearer ${getMerchantToken()}` } });
  if (!response.ok) throw new Error("Unable to export sales report.");
  return response.blob();
};
